import { render } from "./checkmarkIcon.svg?vue&type=template&id=94fab1d8"
const script = {}
script.render = render

export default script